import React, { type FC } from 'react'

import { useIntl } from 'react-intl'

import { EmptyState, SPACING_40, SpacingVertical } from 'mailup-web-components'
import emptyStateImg from 'mailup-web-components/bundle/img/svg/empty-state_access-denied.svg'

import PageContainer from 'Components/PageContainer'

const NoAuthPage: FC = () => {
  const intl = useIntl()

  return (
    <PageContainer>
      <SpacingVertical variant={SPACING_40} />
      <EmptyState
        data-mu-test='access-denied'
        title={intl.formatMessage({ id: 'Load.NoAuthPage.Title' })}
        description={intl.formatMessage({
          id: 'Load.NoAuthPage.Description',
        })}
        thumbSrc={emptyStateImg}
      />
    </PageContainer>
  )
}

export default NoAuthPage
